import {ACTION} from './constants';

let initialState = {
    verifyPanFolio:{
        apiLoaded: false,
    },
    verifyOtp: {
        apiLoaded: false,
    },
    token: {
        apiLoaded: false,
    },
    accountStatementData: {
        apiLoaded: false,
    },
};

export default function AccountStatementReducer(state=initialState, action) {
    switch (action.type) {
        case ACTION.VERIFY_PAN_FOLIO : 
            return {...state, verifyPanFolio:{...action.data, apiLoaded: true}};
        case ACTION.VERIFY_OTP : 
            return {...state, verifyOtp:{...action.data, apiLoaded: true}};
        case ACTION.TOKEN : 
            return {...state, token:{...action.data, apiLoaded: true}};
        case ACTION.ACCOUNT_STATEMENT : 
            return {...state, accountStatementData:{...action.data, apiLoaded: true}};
        case ACTION.ACCOUNT_META:
            return { ...state, accountMetaData: { ...action.data, apiLoaded: true } };
        default:
            return state;    
    }
}